<template>
    <div class="@container">
        <h2 class="scaffold-body mb-2">See how Nadia's coaching changes when she understands your schedule.</h2>
        <div class="grid grid-cols-1 @sm:grid-cols-2 rounded-lgr shadow-lg bg-white">
            <!-- Left: Without calendar -->
            <div class="border flex flex-col">
                <div class="px-6 py-4">
                    <h3 class="inline-block bg-surface-sunken rounded-lgr px-3 py-1 body-small">Without calendar</h3>
                </div>
                <div class="flex flex-col gap-3 px-10 py-6 border-t border-border h-full">
                    <div class="flex items-center gap-2 h-5">
                        <i class="bi bi-calendar text-ink-muted text-lg leading-none" aria-hidden="true"></i>
                    </div>
                    <p class="nadia-chat-semibold text-ink">No awareness into your work week</p>
                    <p class="body text-ink-muted">Coaching based only on what you choose to share — no visibility into your actual meetings, workload, or schedule.</p>
                </div>
            </div>

            <!-- Right: With calendar -->
            <div class="border flex flex-col bg-surface-sunken">
                <div class="px-6 py-4">
                    <h3 class="inline-block bg-surface-raised rounded-lgr px-3 py-1 body-small">With your calendar</h3>
                </div>
                <div class="flex flex-col gap-3 px-10 py-6 border-t border-border h-full">
                    <div class="flex items-center h-5">
                        <span class="body-small text-ink-muted uppercase tracking-wide leading-none">Sample</span>
                    </div>
                    <p class="nadia-chat-semibold text-ink">Burnout risk spotted early</p>
                    <p class="nadia-chat">
                        You've had
                        <strong>4 consecutive days with more than 5 hours of meetings</strong>
                        and limited focus time scheduled this week.
                    </p>
                    <p class="nadia-chat">
                        Between your 1:1 with
                        <span class="inline-flex items-center gap-1 align-bottom bg-surface-raised rounded px-2 py-1 body-small-bold">
                            <PerspectiveDot dimension="EI" size="sm" />
                            Maya </span
                        >, project reviews, and recurring team meetings, your calendar suggests a pace that may be difficult to sustain. Consider protecting dedicated focus blocks
                        before next week fills up.
                    </p>
                    <p class="scaffold-body-small text-chip-nadia-text mt-auto flex items-center gap-1">
                        <i class="bi bi-stars" aria-hidden="true"></i>
                        This is the kind of insight you'll receive once your calendar is connected.
                    </p>
                </div>
            </div>
        </div>
        <div class="flex justify-center items-center mt-6">
            <BaseButton theme="primary" class="inline-flex items-center gap-2" @click="handleConnect">
                Connect your calendar <i class="bi bi-arrow-right icon-bold leading-none" aria-hidden="true" />
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import PerspectiveDot from "~vue/Perspective/PerspectiveDot.vue";
import { useCalendarStore } from "~vue/stores/calendarStore";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const calendarStore = useCalendarStore;
// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.

onMounted(() => logUserInteraction(AmplitudeEventNames.CALENDAR_INTEGRATION_CARD_SHOWN));

const handleConnect = () => calendarStore.openConnectCalendarDialog("calendar_empty_state");
</script>
